<script>
export default {
  name: 'view-pkf',
  props: {
    value: { type: Object, default: () => {} }
  },
  data () {
    return {
      specs: {
        hip_width: 0,
        plank_size: null,
        shoe_length: 0,
        hip_block_width: 0,
        distance_hip_shoe: 0,
        distance_knee_shoe: 0
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) this.specs = { ...this.value }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <b-row no-gutters align-v="start" align-h="center">
    <b-col align-self="start">
      <h6 class="mt-4">{{ $t('specifications') }}</h6>
      <p class="p-0 my-2 mb-2">
        <i class="text-muted mr-2">A - {{ $t(`attribute.hip_width.key`) }}: </i>
        {{ $t(`attribute.hip_width.value`, { value: specs.hip_width }) }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2"
          >B - {{ $t(`attribute.distance_hip_shoe.key`) }}:
        </i>
        {{
          $t(`attribute.distance_hip_shoe.value`, {
            value: specs.distance_hip_shoe
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2"
          >C - {{ $t(`attribute.distance_knee_shoe.key`) }}:
        </i>
        {{
          $t(`attribute.distance_knee_shoe.value`, {
            value: specs.distance_knee_shoe
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2"
          >D - {{ $t(`attribute.shoe_length.key`) }}:
        </i>
        {{
          $t(`attribute.shoe_length.value`, {
            value: specs.shoe_length
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2"
          >E - {{ $t(`attribute.hip_block_width.key`) }}:
        </i>
        {{
          $t(`attribute.hip_block_width.value`, {
            value: specs.hip_block_width
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2" v-if="!!specs.plank_size">
        <i class="text-muted mr-2">{{ $t(`attribute.plank_size.key`) }}: </i>
        {{
          $t(`attribute.plank_size.value`, {
            value: $t(`attribute.plank_size.${specs.plank_size}`)
          })
        }}
      </p>
    </b-col>
    <b-col cols="7" align-self="start"
      ><img src="@/assets/images/forms/pkf.png" alt class="dimg-fluid w-100"
    /></b-col>
  </b-row>
</template>
